export default str => parseInt(str, 10) || 0;
